module.exports = __webpack_public_path__ + "img/kouling.67e23fb7.png";